import React from 'react';
import { YMaps, Map, Placemark } from 'react-yandex-maps';
import Grid from '@material-ui/core/Grid';
import ContactInfo from '../Components/ContactComponent';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    [theme.breakpoints.down('xs')]: {
      paddingTop: '2rem',
    },
    paddingTop: '5rem',
    minHeight: '100vh',
  },
  main: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  gridMap: {
    minHeight: '20rem',
    margin: '2rem',
  },
  grid: {
    margin: '2rem',
  },
}));

const Contact = () => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <Typography
        variant="h5"
        align="center"
        color="textSecondary"
        component="p"
      >
        Контакты
      </Typography>
      <Grid className={classes.main} container>
        <Grid className={classes.gridMap} item xs={12} sm={5}>
          <YMaps>
            <Map
              defaultState={{
                center: [54.7117, 20.507416],
                zoom: 16,
                controls: ['zoomControl', 'fullscreenControl'],
              }}
              style={{ width: '100%', height: '100%' }}
              modules={['control.ZoomControl', 'control.FullscreenControl']}
            >
              <Placemark
                modules={['geoObject.addon.balloon']}
                defaultGeometry={[54.7117, 20.507416]}
              />
            </Map>
          </YMaps>
        </Grid>
        <Grid className={classes.grid} item xs={12} sm={5}>
          <ContactInfo />
        </Grid>
      </Grid>
    </div>
  );
};
export default Contact;
